@if (dataLoaded && options().data && options().form) {
  <div class="d-flex flex-column">
    <form
      [formGroup]="options().form!"
      [id]="options().id"
      #frm="ngForm"
      (ngSubmit)="options().onSubmit?.()"
    >
      @for (item of options().data; track item; let i = $index) {
        <div class="flex-row">
          <ng-container
            [ngComponentOutlet]="item.component || null"
            [ngComponentOutletInputs]="{ options: item.componentOptions }"
            #outlet="ngComponentOutlet"
          />
        </div>
      }
    </form>
  </div>
}
